module.exports = __webpack_public_path__ + "static/media/lek.9f18a125.png";